import { render, staticRenderFns } from "./CapsVTextArea.vue?vue&type=template&id=077ede48"
import script from "./CapsVTextArea.vue?vue&type=script&lang=js"
export * from "./CapsVTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports